import type { ProductTourDefinition } from './types';

export const buildTourStorageKey = ({
  id,
  version,
  legacyStorageKey,
}: Pick<
  ProductTourDefinition,
  'id' | 'version' | 'legacyStorageKey'
>): string => legacyStorageKey ?? `terra-tour:${id}:v${version}`;

export const createLocalTourPersistence = ({
  storageKey,
}: {
  storageKey: string;
}): {
  isCompleted: () => boolean;
  markCompleted: () => void;
  clearCompleted: () => void;
} => ({
  isCompleted: () => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.localStorage.getItem(storageKey) === 'true';
  },
  markCompleted: () => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(storageKey, 'true');
  },
  clearCompleted: () => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.removeItem(storageKey);
  },
});
